import { lazy } from 'react';

const TemplateGallery = lazy(() => import('../../views/TemplateGallery/index'));
const EmailTemplateForm = lazy(() => import('../../views/TemplateGallery/components/Form'));

const TemplateGalleryRoutes = [
    // {
    //     path: '/settings/email-templates',
    //     element: <TemplateGallery />
    // },
    {
        path: '/settings/email-templates',
        element: <TemplateGallery />,
        meta: {
            appLayout: true,
            className: 'email-application'
        }
        // dbId: modules.settings_template_gallery
    },
    {
        path: '/settings/email-templates/:folder',
        element: <TemplateGallery />,
        meta: {
            appLayout: true,
            className: 'email-application'
        }
    },
    {
        path: '/settings/email-templates/add',
        element: <EmailTemplateForm />
        // dbId: modules.settings_add_template
    },
    {
        path: '/settings/email-templates/edit/:id',
        element: <EmailTemplateForm />
    }
];

export default TemplateGalleryRoutes;
